import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Contact from './views/Contact.vue'
import About from './views/About.vue'
import Person from './views/Person.vue'
import Yewu from './views/Yewu.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: '长沙厚物教育科技有限公司官网',
        keepAlive: true
      }
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home,
      meta: {
        title: '长沙厚物教育科技有限公司官网',
        keepAlive: true
      }
    },
    {
      path: '/Contact',
      name: 'Contact',
      component: Contact,
      meta: {
        title: '联系我们',
        keepAlive: true
      }
    },
    {
      path: '/About',
      name: 'About',
      component: About,
      meta: {
        title: '走进红杏林',
        keepAlive: true
      }
    },
    {
      path: '/Yewu',
      name: 'Yewu',
      component: Yewu,
      meta: {
        title: '主营业务',
        keepAlive: true
      }
    },
    {
      path: '/Person',
      name: 'Person',
      component: Person,
      meta: {
        title: '杏林名家',
        keepAlive: true
      }
    }
  ]
})
